import { render } from "./DotsLoader.vue?vue&type=template&id=38103732&scoped=true&ts=true"
import script from "./DotsLoader.vue?vue&type=script&lang=ts"
export * from "./DotsLoader.vue?vue&type=script&lang=ts"

import "./DotsLoader.vue?vue&type=style&index=0&id=38103732&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38103732"]])

export default __exports__